var config = require('../../server/config.js')
export default {
  prefix: 'chessPlaza',
  lStorage: window.localStorage, // window.sessionStorage, // window.localStorage, // Pruebas de torneos con sessionStorage
  setPrefix (name) {
    this.prefix = name
    if (config.debug) {
      window.sessionStorage.tabID = window.sessionStorage.tabID ? window.sessionStorage.tabID : Math.random()
      this.prefix = name + window.sessionStorage.tabID
      console.log('* Prefijo Debug', this.prefix)
    } else {
      this.prefix = name
      console.log('* Prefijo ', this.prefix)
    }
  },
  get (name, value = false) {
    let data = this.lStorage.getItem(this.prefix + '-' + name)
    if (data) {
      var ret = JSON.parse(data)
      return ret
    } else {
      return this.set(name, value)
    }
  },
  normalizeString (str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  },
  // Función recursiva para normalizar todos los datos de un objeto
  normalizeObject (obj) {
    for (const key in obj) {
      // console.log(`Procesando key: ${key}, valor: ${obj[key]}`)
      if (obj[key] !== undefined && typeof obj[key] === 'string') {
        // console.log(`Normalizando string: ${obj[key]}`)
        obj[key] = this.normalizeString(obj[key]) // Aquí podrías estar alterando algo inesperado
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        // console.log(`Entrando recursivamente en objeto: ${key}`)
        this.normalizeObject(obj[key]) // Recursión
      } else {
        // -- números y booleanos
        // console.warn(`Tipo no soportado: ${key} = ${obj[key]}`)
      }
    }
  },
  set (name, data) {
    // Quitar acentos siempre (Problema con acentos en el emit, hasta que se encuentre el problema)
    /* if (typeof data === 'string') {
      this.normalizeString(data)
    } else {
      this.normalizeObject(data)
    } */
    //
    // window.alert(this.prefix + ' - ' + name + ' - ' + JSON.stringify(data))
    this.lStorage.setItem(this.prefix + '-' + name, JSON.stringify(data))
    return this.get(name)
  },
  setNormalize (name, data) {
    // window.alert(this.prefix + ' - ' + name + ' - ' + JSON.stringify(data))
    /* if (typeof data === 'string') {
      this.normalizeString(data)
    } else {
      this.normalizeObject(data)
    } */
    this.lStorage.setItem(this.prefix + '-' + name, JSON.stringify(data))
    return this.get(name)
  },
  del (name) {
    this.lStorage.removeItem(this.prefix + '-' + name)
  },
  clearLocal (reload = false) {
    var prefixRegex = new RegExp('^' + this.prefix)
    var store = this.lStorage
    Object.keys(store).forEach((key) => {
      if (prefixRegex.test(key) && key.includes('styleBoard') === false) {
        store.removeItem(key)
      }
    })
    if (reload) {
      window.location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lstorage.js